var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVerify = function SvgIconVerify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_verify_svg2__a",
    x1: 24.62,
    x2: 336.86,
    y1: 431.8,
    y2: 90.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_verify_svg2__a",
    id: "icon_verify_svg2__b",
    x1: 162.58,
    x2: 474.81,
    y1: 557.9,
    y2: 216.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_verify_svg2__a",
    id: "icon_verify_svg2__c",
    x1: 164.12,
    x2: 476.35,
    y1: 559.31,
    y2: 217.72
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M229.59 437.5H23.76l8-32.23c3.9-15.48 15.21-27.69 30.29-32.67l84.44-28.19c22.29-9.25 34.56-36.12 34.56-75.66 0-3.1-1.37-6.04-3.75-8.02-12.75-10.58-26.46-27.31-26.46-39.06 0-14.21-5.81-22.29-11.4-26.25-2.73-7.48-7-20.87-7.33-29.42 5.25-.54 9.35-4.98 9.35-10.37 0-3.6.27-8.46.56-14.48.58-10.56 1.31-24.65 1.31-42.19 0-26.75 36.25-78.12 85.83-78.12 45.21 0 62.75 24.77 63.12 31.04 0 7.96 6.65 11.29 9.79 12.9 5.21 2.6 13.94 7 13.94 34.19v56.67c0 5.75 3.4 10.06 9.12 10.06.33.25.83.98 1.23 1.71.75 4.94 5.06 8.44 10.29 8.44 5.75 0 10.42-5.08 10.42-10.83 0-1.12-.17-2.25-.52-3.31-1.33-3.94-4.52-9.65-9.69-13.21V98.98c0-33.14-11.35-45.04-24.37-52.25C308.23 28.38 282.44 0 229.17 0 170.3 0 122.51 59.88 122.51 98.96c0 17.08-.73 30.81-1.25 41.1-.17 3.08-.31 5.85-.44 8.35-4.77 3.29-7.94 8.71-9.25 14.1-.21.81-.31 1.65-.31 2.48 0 15.71 9.06 38.96 10.1 41.58 1.23 3.06 2.9 5.02 6.06 5.87.02.02 2.58 1.58 2.58 9.23 0 21.79 20.56 43.04 30.15 51.75-.79 27.58-8.54 46.29-20.96 51.48l-83.71 27.9c-21.83 7.19-38.27 24.9-43.94 47.37L.31 445.39a10.443 10.443 0 0 0 10.13 12.94H229.6c5.75 0 10.42-4.67 10.42-10.42s-4.67-10.42-10.42-10.42Z",
    style: {
      fill: "url(#icon_verify_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.92 247.56-114.58-38.69c-2.15-.73-4.5-.73-6.67 0l-114.58 38.69a10.45 10.45 0 0 0-7.08 9.87v87.06c0 102.46 116 152.6 120.96 154.66 1.29.56 2.67.83 4.04.83s2.75-.27 4.04-.81c4.96-2.08 120.96-52.23 120.96-154.68v-87.06c0-4.48-2.85-8.46-7.08-9.87Zm-13.75 96.94c0 78.66-84.5 124.1-104.16 133.62-19.69-9.5-104.16-54.77-104.16-133.62v-79.58l104.16-35.17 104.16 35.17z",
    style: {
      fill: "url(#icon_verify_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.07 326.81c-3.58-4.46-10.12-5.21-14.65-1.62-4.5 3.6-5.21 10.15-1.62 14.65l41.67 52.08c1.85 2.31 4.58 3.73 7.56 3.9.17.02.37.02.56.02 2.75 0 5.42-1.08 7.35-3.06l72.91-72.91c4.06-4.06 4.06-10.67 0-14.73s-10.67-4.06-14.73 0l-64.69 64.69-34.37-43Z",
    style: {
      fill: "url(#icon_verify_svg2__c)"
    }
  }));
};
export default SvgIconVerify;